import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import CategorySection from '../components/CategorySection';
import AboutSection from '../components/AboutSection';
import { LOGO_URL } from '../utils/seo';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Timmers BV - Groothandel in Glas, Glasbeslag & Artikelen</title>
        <meta name="description" content="Timmers BV is uw groothandel voor glas, glasbeslag en beglazingsmaterialen. Gespecialiseerd in glastoepassingen en eigen transport door heel Nederland en Vlaanderen." />
        <link rel="canonical" href="https://timmers-bv.nl" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Timmers BV - Groothandel in Glas, Glasbeslag & Artikelen" />
        <meta property="og:description" content="Groothandel in glas, glasbeslag en beglazingsmaterialen. Eigen transport door heel Nederland en Vlaanderen." />
        <meta property="og:image" content={LOGO_URL} />
        <meta property="og:url" content="https://timmers-bv.nl" />
        <meta property="og:locale" content="nl_NL" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Timmers BV",
            "url": "https://timmers-bv.nl",
            "logo": LOGO_URL,
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+31-162-461175",
              "contactType": "customer service",
              "availableLanguage": ["Dutch"]
            },
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Krombraak 8-10",
              "addressLocality": "Oosterhout",
              "postalCode": "4906 CR",
              "addressCountry": "NL"
            }
          })}
        </script>
      </Helmet>
      <Hero />

      {/* Category blocks - direct entry points above featured products */}
      <CategorySection />

      <div className="basic-section">
        <div className="container">
          <div className="product-related">
            <div className="product-slider-title">
              <h2 className="h2">Onze hardlopers</h2>
            </div>
            <baka-featured-products></baka-featured-products>
          </div>
        </div>
      </div>

      <AboutSection />
    </>
  );
};

export default Home;
